// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c8Fdj","question":"styles_question__2fhXj","description":"styles_description__2ae-q"};